import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "row" }

import { ref, defineAsyncComponent } from 'vue'

export default /*@__PURE__*/_defineComponent({
  __name: 'indexRange',
  setup(__props) {

const DefultRang = defineAsyncComponent(() => import("@/components/theme/advance/rangslider/DefultRang.vue"))
const MinMax = defineAsyncComponent(() => import("@/components/theme/advance/rangslider/MinMax.vue"))
const PrefixRang = defineAsyncComponent(() => import("@/components/theme/advance/rangslider/PrefixRang.vue"))
const NegativeRang = defineAsyncComponent(() => import("@/components/theme/advance/rangslider/NegativeRang.vue"))
const StepsRange = defineAsyncComponent(() => import("@/components/theme/advance/rangslider/StepsRange.vue"))
const CustomRang = defineAsyncComponent(() => import("@/components/theme/advance/rangslider/CustomRang.vue"))
const ColorRang = defineAsyncComponent(() => import("@/components/theme/advance/rangslider/ColorRang.vue"))
const PrettifyRang = defineAsyncComponent(() => import("@/components/theme/advance/rangslider/PrettifyRang.vue"))

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_unref(DefultRang)),
      _createVNode(_unref(MinMax)),
      _createVNode(_unref(PrefixRang)),
      _createVNode(_unref(NegativeRang)),
      _createVNode(_unref(StepsRange)),
      _createVNode(_unref(CustomRang)),
      _createVNode(_unref(PrettifyRang)),
      _createVNode(_unref(ColorRang))
    ])
  ]))
}
}

})